import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, Tooltip, message, Modal } from 'antd';
import $ from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import moment from 'moment';
import { saveParams } from '../../../actions/noticeActions';
import MoreCrcHandover from './MoreCrcHandover';

const parseQueryConditions = (queryConditions,isSplitValue, splitType = ',') => {
    const fields = (queryConditions || '').split(splitType);
    const params = {};
    for (let i = 0, len = fields.length; i < len; i++) {
        const keyValue = fields[i].split('=');
        if(isSplitValue){
            params[keyValue[0]] =( keyValue[1]+'').replace(/_/g,',');
        }else{
            params[keyValue[0]] = keyValue[1];
        }
    }
    
    return params;
};

const setCenter = (setSession, item) => {
    setSession.invId = item.investigationId;
    setSession.invName = item.investigationName;
    setSession.investigationSiteCode = item.investigationSiteCode;
    setSession.investigationSiteName = item.investigationSiteName;
    setSession.siteId = item.investigationSiteId;
};

class CrcHandover extends Component {
    state = {
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        loading: false,
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        const { pagination } = this.state;
        const { pageSize, current } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryGeneralNoticeList,
            data: {
                limit: pageSize,
                offset: current,
                noticeType: 'HANDOVER_REQUIREMENT',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {
                sessionStorage[k] = v;
            }
        }
    }

    //标记已处理
    handleComplate = (markType, userScheduleId) => {
        const options = {
            method: 'POST',
            url: API_URL.notice.markScheduleDeal,
            data: {
                markType,
                userScheduleId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res && res.success) {
                    message.success(res.success);
                    this.loadData();
                    window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
                } else {
                    message.error((res && res.error) || '标记失败');
                }
            },
        };
        $.sendRequest(options);
    }

    //点击消息回调
    clickNotice = (text , record , index) => {
        const {
            noticeId,
            queryConditions, 
            relateId, 
            roleCode, 
            investigationId = '',
            investigationName = '',
            investigationSiteId = '', 
            investigationSiteName = '',
            investigationSiteCode = '',
        } = record;
        let path = `/#/execute/transfer/${relateId}`;
        let params = {
            ...parseQueryConditions(queryConditions), 
            investigationId, 
            investigationName, 
            investigationSiteId, 
            investigationSiteName, 
            investigationSiteCode,
            cur: 'CRC',
        };
        let setSession = {};
        setCenter(setSession, params);
        setSession.curRole = roleCode;

        this.confirmNoticeReadByOne(noticeId);
        // 保存页面查询参数至store
        const { saveParams } = this.props;
        if (Object.keys(params).length !== 0) {
            saveParams({...params});
        }
        
        this.setSession(setSession);
        location.href = path;
    }

    //确认已读
    confirmNoticeReadByOne = (noticeId) => {
        const options = {
            method: 'POST',
            url: API_URL.home.confirmNoticeReadByOne,
            data: { noticeId },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
                window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
            }
        };
        $.sendRequest(options);
    }

    showMoreInfo = () => {
        const { data } = this.state;
        this.moreCrcHandoverRef.show(data);
    }

    render() {
        const { data, loading } = this.state;
        const content = data.slice(0,8).map((el, index) => {
            return (
                <div className='backlogli'>
                    <Tooltip title={el.noticeInfo} overlayStyle={{ maxWidth: 350 }}>
                        <div className='left' style={{color: el.readStatus !== 'READ' ? '#5750b7': 'rgba(0,0,0,0.6)'}} onClick={() => this.clickNotice(null, el, index)}>
                            {`${el.noticeInfo}`}
                        </div>    
                    </Tooltip>
                    <div className='right'>
                        <Popconfirm title='确定标记此待办事项已处理吗?' 
                            onConfirm={() => this.confirmNoticeReadByOne(el.noticeId)} 
                            okText="确定" 
                            cancelText="取消"
                        >
                            <a>标记为已处理</a>
                        </Popconfirm>
                        <br />
                        <span style={{color:'#cccccc'}}>{moment(el.createTime).format('YYYY-MM-DD')}</span>
                    </div>
                </div>
            )
        })
        return (
            <div className="flexItem outer">
                <div className="modTitle">进行中的CRC交接记录</div>
                <div>
                    {content}
                    <div className='data_null'>
                        {
                            data.length == 0 && <span><i className='anticon anticon-frown-o'></i>暂无数据</span>
                        }
                    </div>
                    <div className='more_btn'>
                        {
                            (data.length > 6) && <a onClick={this.showMoreInfo}>{`查看更多>>`}</a>
                        }
                    </div>
                </div>
                <MoreCrcHandover 
                    ref={el => this.moreCrcHandoverRef = el}
                    clickNotice={this.clickNotice}
                    confirmNoticeReadByOne={this.confirmNoticeReadByOne}
                />
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    params: state.noticeState.params || {},
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapSateToProps, mapDispatchToProps)(CrcHandover);



// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/CrcHandover.js